import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { getIsMobileTraffic } from 'selectors/shared/mobileTraffic'
const mapStateToProps = createStructuredSelector({
  isMobile: getIsMobileTraffic,
})
export type ConnectorProps = {
  isMobile: boolean
}
export default connect(mapStateToProps)